import { CSSProperties } from 'react';
import { IntersectionLane } from '@kinetic-ui/data-layer';
import { LatLngTuple } from 'leaflet';
import { LngLatLike } from 'maplibre-gl';

export interface DragElementOwnProps {
  /** this is actually a LngLat. Name is a lie */
  centerLatLng: LngLatLike;
  /** this is true, it returns `[Lat, Lng]` */
  setCenterLatLng(coordinates: LatLngTuple | null): void;
  deleteable?: boolean;
  altSVG?: React.ReactElement;
  disabled?: boolean;
  fill?: string;
  stroke?: string;
  showMoveCursor?: boolean;
}

export interface DragLaneProps {
  connectable?: boolean;
  departure?: boolean;
  disabled?: boolean;
  lane: IntersectionLane;
  selected?: boolean;
  onClickLane?: (event?: React.MouseEvent) => void;
  onClickConnect?: (id: string) => void;
  onMouseOut?: (event?: React.MouseEvent) => void;
  onMouseOver?: (event?: React.MouseEvent) => void;
  latLngToContainerPoint: (lngLat: LatLngTuple) => number[];
}

export type DragElementProps = DragElementOwnProps;

export enum SVGFilterStatus {
  OUTLINE = 'outline',
  SELECTED = 'selected',
  BOLD = 'bold',
  RED_SELECTED = 'redSelected',
}

export interface PathProps {
  color: string;
  permissive?: boolean;
  flashRate?: number;
  status?: SVGFilterStatus;
  style?: CSSProperties;
  fillOpacity?: number;
  intersectionId?: string;
  bearing?: number;
  height: number;
  width: number;
}
